(function() {
    'use strict';

    angular
        .module('app.test')
        .component('sc3Test', {
            templateUrl: 'app/test/test.component.html',
            controller: TestComponent,
            bindings: {
                data: '<'
            }
        });

    TestComponent.$inject = [];
    function TestComponent() {
        var ctrl = this;
    }
})();